import { useEffect } from "react";
import "@/App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";
import Testimonials from "@/components/Testimonials";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import About from "@/pages/About";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import GCCHireIndia from "@/pages/services/GCCHireIndia";

const Home = () => {
  useEffect(() => {
    // Remove Emergent badge if it exists
    const removeBadge = () => {
      const badge = document.getElementById('emergent-badge');
      if (badge) {
        badge.remove();
      }

      // Also remove any links with emergent.sh
      const emergentLinks = document.querySelectorAll('a[href*="emergent.sh"]');
      emergentLinks.forEach(link => link.remove());
    };

    removeBadge();
    const timeoutId = setTimeout(removeBadge, 1000);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <Testimonials />
      <CTASection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:slug" element={<ServiceDetail />} />
          <Route path="/gcc-hire-india" element={<GCCHireIndia />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
